import type {HTMLAttributes, ReactNode} from 'react';

import {cn} from '../../../helpers/cn';
import {safeAreaClassName, shellClassName} from '../../constants';

export type FullScreenLayoutProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  /** Center content vertically — login, register, empty states. */
  centerContent?: boolean;
};

/**
 * Full-height shell with no header or bottom nav.
 * Matches routes with `hasHeader: false` and `hasNavigate: false` (splash, auth, immersive flows).
 */
export function FullScreenLayout({
  children,
  centerContent = false,
  className,
  ...props
}: FullScreenLayoutProps) {
  return (
    <div className={cn(shellClassName, className)} {...props}>
      <div
        className={cn(
          safeAreaClassName,
          'flex flex-1 flex-col',
          centerContent && 'items-center justify-center p-4'
        )}
      >
        {children}
      </div>
    </div>
  );
}
